import { render } from "./inviteJob.vue?vue&type=template&id=776a5989&scoped=true"
import script from "./inviteJob.vue?vue&type=script&lang=js"
export * from "./inviteJob.vue?vue&type=script&lang=js"

import "./inviteJob.vue?vue&type=style&index=0&id=776a5989&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776a5989"]])

export default __exports__